import React from "react";
import "./status-badge.css";

/**
 * Both cases are members because the labels arrive from the API as the contract's enum KEYS —
 * `CardStatus[n]` gives "Active", "Revoked", "Manufactured", "Suspended", "Unassigned" — while
 * some call sites still pass lowercase. The variant class is case-folded below, so either works.
 */
export type StatusVariant =
  | "active"
  | "blocked"
  | "pending"
  | "Revoked"
  | "Active"
  | "Blocked"
  | "Pending"
  | "Manufactured"
  | "Unassigned"
  | "Expired"
  | "Suspended"
  | "Unknown"
  // Terminal statuses (PosByTreasury.statusLabel) arrive upper-case straight off the chain enum.
  | "ACTIVE"
  | "BLOCKED"
  | "UNASSIGNED"
  | "REVOKED"
  | "SUSPENDED"
  | "IDLE";

interface Props {
  status: StatusVariant;
  /** Override the display label; defaults to capitalised status */
  label?: string;
}

function StatusBadge({ status, label }: Props) {
  const text = label ?? status?.charAt(0).toUpperCase() + status?.slice(1);
  // Case-folded: the CSS variants are lowercase, so an "Active" straight from the API used to
  // produce .status-badge--Active — a class with no rule, i.e. a pill with no colour at all.
  const variant = status?.toLowerCase() ?? "unknown";
  return (
    <span className={`status-badge status-badge--${variant}`}>{text}</span>
  );
}

export default StatusBadge;
